import { Ability } from "ember-can";
import type Patient from "parog-web/models/patient";

export default class HemodialysisSessionAbility extends Ability {
  declare patient: Patient | undefined;

  get canCreate(): boolean {
    return !this.patient?.draftHemodialysisSession;
  }
}
